<div class="image-detail">
  @if (cover) {
    <img class="preview" [src]="cover" [alt]="item.name || 'Main image'" />
  } @else {
    <div class="preview ib-preview-empty">No main image</div>
  }
</div>

<div class="back-to-list">
  <a href="#" (click)="$event.preventDefault()">
    <span class="icon ib-arrow-left"></span> Back to {{ categoryLabel }} list
  </a>
</div>

<h1 class="h2">
  <b>{{ item.name || 'Untitled item' }}</b>
</h1>

<div class="theatre-info">
  <span class="me-3">
    <span class="icon ib-star-solid green pe-1"></span>
    <b>{{ reviewScore }}</b>
    <small
      ><span class="gray">(based on </span><b>{{ reviewVotes }}</b
      ><span class="gray"> votes)</span></small
    >
  </span>
  @if (venueLine) {
    <span class="theatre">{{ venueLine }}</span>
    <a
      class="view-on-map"
      [href]="item.mapUrl || '#'"
      [attr.target]="item.mapUrl ? '_blank' : null"
      (click)="!item.mapUrl && $event.preventDefault()"
    >
      <strong><span class="icon ib-map-marker"></span> View on Map</strong>
    </a>
  }
  @if (showTimeLabel) {
    <span class="time">
      <span class="icon ib-clock"></span>
      {{ showTimeLabel }}
    </span>
  }
</div>

@if ((item.categories?.length ?? 0) > 0) {
  <div class="categories">
    @for (cat of item.categories; track cat.category) {
      <a class="tag text-uppercase" href="#" (click)="$event.preventDefault()">{{ cat.category }}</a>
    }
  </div>
}

<div class="menu-content">
  <div class="row">
    <div class="col-md-5 order-2 order-md-1 mb-3">
      <ul>
        <li>
          <a
            href="#overview"
            [class.active]="activeTab === 'overview'"
            (click)="go($event, 'overview')"
            >Overview</a
          >
        </li>
        <li>
          <a
            href="#availability"
            [class.active]="activeTab === 'availability'"
            (click)="go($event, 'availability')"
            >Availability</a
          >
        </li>
        <li>
          <a
            href="#gallery"
            [class.active]="activeTab === 'gallery'"
            (click)="go($event, 'gallery')"
            >Gallery</a
          >
        </li>
      </ul>
    </div>

    <div class="col-md-7 order-1 order-md-2">
      <div class="row row-small-padding">
        <div class="col-7 col-sm-5 col-lg-6 col-xl-6 text-md-end mb-3">
          @if (item.phone) {
            <small class="gray">For more Ticket Info</small>
            <div class="gray fs-5">
              <span class="icon ib-phone"></span>
              <strong>{{ item.phone }}</strong>
            </div>
          }
        </div>
        <div class="col-5 col-sm-4 col-lg-3 col-xl-4 text-end mb-3">
          @if (startingPriceLabel) {
            <small class="gray">Tickets starting at</small>
            <div class="price-block">
              <span class="cost green">{{ startingPriceLabel }}</span>
              @if (oldPriceLabel) {
                <span class="cost cost-old">{{ oldPriceLabel }}</span>
              }
            </div>
          }
        </div>
        <div class="col-12 col-sm-3 col-lg-3 col-xl-2 text-end mb-4">
          <a class="btn btn-primary w-100" href="#availability" (click)="go($event, 'availability')"
            >Buy now</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
